module.exports = __webpack_public_path__ + "static/media/valpo-8.6690d557.jpg";